import React from "react";
import './assets/css/project.css';
import './assets/css/theme-red.css';
import './assets/css/developer.css';

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import * as RouteInfo from './RouteConstents';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Login from "./Elements/Login";
import Signup from "./Elements/Signup";
import PhoneOTP from "./Elements/PhoneOTP";

import PageNotFound from "./Elements/404";
import ForgotPassword from "./Elements/ForgotPassword";
import ResetPassword from "./Elements/ResetPassword";

import CompleteProfile from "./Elements/CompleteProfile";


import HomeDashboard from "./Components/Dashboard";

import { ProtectedRoute } from "./ProtectedRoute";
import { CheckLogged } from "./Elements/CheckLogged";

import VideoList from "./Components/Videos/List";
import VideoView from "./Components/Videos/View";

import TestSeriesList from "./Components/TestSeries/TestSeriesList";
import QuizList from "./Components/TestSeries/QuizList";
import ExamStartPage from "./Components/TestSeries/ExamStartPage";
import ExamPage from "./Components/TestSeries/ExamPage";

import ProfilePage from "./Components/Profile/ProfilePage";

import ExamReport from "./Components/TestSeries/ExamReport";

import SingleExamReport from "./Components/TestSeries/SingleExamReport";

import ExamReportDetails from "./Components/TestSeries/ExamReportDetails";

function App() {
  return (
    <Router>
      <ToastContainer />
      <Routes>
        <Route path="*" element={<PageNotFound />} />
        
        <Route exact path='/' element={<CheckLogged> <Login /> </CheckLogged>} />
        <Route path={RouteInfo.ROUTE_SIGN_IN} element={<CheckLogged> <Login /> </CheckLogged>} />
        <Route path={RouteInfo.ROUTE_SIGN_UP} element={<CheckLogged> <Signup /> </CheckLogged>} />
        <Route path={RouteInfo.ROUTE_PHONE_OTP} element={<PhoneOTP />} />

        <Route path={RouteInfo.ROUTE_COMPLETE_PROFILE} element={<CompleteProfile />} />
        
        <Route path={RouteInfo.ROUTE_FORGOT_PASSWORD} element={<ForgotPassword />} />
        <Route path={RouteInfo.ROUTE_RESET_PASSWORD} element={<ResetPassword />} />
        
        <Route 
          path={RouteInfo.ROUTE_DASHBOARD}
          element={<ProtectedRoute> <HomeDashboard /> </ProtectedRoute>} 
        />

        <Route 
          path={RouteInfo.ROUTE_VIDEO_PAGE}
          element={<ProtectedRoute> <VideoList /> </ProtectedRoute>} 
        />

        <Route 
          path={RouteInfo.ROUTE_VIDEO_INFO_PAGE}
          element={<ProtectedRoute> <VideoView /> </ProtectedRoute>} 
        />

        <Route 
          path={RouteInfo.ROUTE_TEST_SERIES_PAGE}
          element={<ProtectedRoute> <TestSeriesList /> </ProtectedRoute>} 
        />

        <Route 
          path={RouteInfo.ROUTE_PRACTISE_TEST_PAGE}
          element={<ProtectedRoute> <QuizList /> </ProtectedRoute>} 
        />

        <Route 
          path={RouteInfo.ROUTE_EXAM_RULES_PAGE}
          element={<ProtectedRoute> <ExamStartPage /> </ProtectedRoute>} 
        />

        <Route 
          path={RouteInfo.ROUTE_EXAM_PAGE}
          element={<ProtectedRoute> <ExamPage /> </ProtectedRoute>} 
        />

        <Route 
          path={RouteInfo.ROUTE_MY_PROFILE}
          element={<ProtectedRoute> <ProfilePage /> </ProtectedRoute>} 
        />

        <Route 
          path={RouteInfo.ROUTE_EXAM_REPORT}
          element={<ProtectedRoute> <ExamReport /> </ProtectedRoute>} 
        />

        <Route 
          path={RouteInfo.ROUTE_EXAM_SINGLE_REPORT}
          element={<ProtectedRoute> <SingleExamReport /> </ProtectedRoute>} 
        />

        <Route 
          path={RouteInfo.ROUTE_EXAM_REPORT_DETAILS}
          element={<ProtectedRoute> <ExamReportDetails /> </ProtectedRoute>} 
        />


      </Routes>
    
    </Router>  
  );
}

export default App;
